import { SheetFooter } from '@/components/ui-library/sheet'
import { cn } from '@/utils'

interface SidesheetFooterProps {
  children: React.ReactNode
  className?: string
}
const SidesheetFooter: React.FC<SidesheetFooterProps> = ({ children, className }) => {
  
  return (
    <SheetFooter id='modal-footer-container'
      className={cn(
      'fixed bottom-0 w-full bg-white shadow-[0px_0px_8px_4px_rgba(0,0,0,0.10)] mt-auto p-4',
      '[&>button]:m-0',
      className
    )}>
      {children}
    </SheetFooter>
  )
}

export default SidesheetFooter